import "./App.css";
import "./theme/theme.css";

import * as React from "react";

import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { api, setAuthToken } from "./api/api";
import { useAppDispatch, useAppSelector } from "./store";

import Admin from "./pages/admin/Admin";
import Auth from "./pages/login/Auth";
import CColors from "./theme/CColors";
import Courses from "./pages/app/courses/Courses";
import { Lessons } from "./pages/app/lessons/Lessons";
import Login from "./pages/login/Login";
import { ModalProvider } from "./context/ModalContext";
import ProfTest from "./pages/proftest/ProfTest";
import ProfTestCreate from "./pages/proftest/ProfTestCreate";
import UserWorkspace from "./pages/app/workspace/UserWorkspace";
import { appActions } from "./store/slices/appSlice";
import { useAuth } from "./hooks/useAuth";
import { useLoaUser } from "./pages/app/lessons/lessonHooks";
import { userActions } from "./store/slices/userSlice";

function App() {
  const ready = useAppSelector((state) => state.app.ready);
  const { loaUser } = useLoaUser();
  const dispatch = useAppDispatch();
  const { authUser } = useAuth();

  React.useEffect(() => {
    const setToken = async () => {
      if (authUser) {
        const token = await authUser.getIdToken();
        setAuthToken(token); // Attach token to all API requests
        api.app.getUser().then((user) => {
          dispatch(userActions.setUser(user));
          dispatch(appActions.ready());
        });
      } else {
        dispatch(userActions.clearUser());
      }
    };

    setToken();
  }, [authUser, dispatch]);

  /* 
  // sessions aren't reliable as 3rd party cookies in an iframe can be blocked
  React.useEffect(() => {
    fetch("/login/verify-session", {
      credentials: "include", // Important: This sends cookies with the request
    }) // move to api
      .then((resp) => {
        if (resp.ok) return resp.json();
        throw new Error("Session verification failed");
      })
      .then((data) => {
        console.log("Session verification data:", data);
        if (data.authenticated) {
          dispatch(userActions.setUser(data.user));
        } else {
          // dispatch(userActions.clearUser());
          dispatch(appActions.ready());
        }
      })
      .catch((err) => {
        console.error("Session verification error:", err);
        // dispatch(userActions.clearUser());
      })
      .finally(() => {
        // dispatch(appActions.ready());
      });
  }, [dispatch]); */

  const path = window.location.pathname;
  const admin = !!loaUser?.admin;

  console.log("- - - App", {
    authUser: !!authUser,
    loaUser: !!loaUser,
    ready,
    admin,
    path,
  });

  return (
    <div className="app">
      <ModalProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Login logout={true} />} />
            <Route path="/exam" element={<ProfTest />} />
            <Route path="/exam/:recId" element={<ProfTest />} />
            <Route path="/exam-create-form" element={<ProfTestCreate />} />
            <Route path="/colors" element={<CColors />} />

            {ready && (
              <Route path="/workspace/:id" element={<UserWorkspace />} />
            )}
            {ready && <Route path="/lessons" element={<Lessons />} />}
            {ready && <Route path="/courses" element={<Courses />} />}

            {admin && <Route path="/admins/:mode/:id" element={<Admin />} />}
            {admin && <Route path="/admins/:mode/" element={<Admin />} />}
            {admin && <Route path="/admins" element={<Admin />} />}
          </Routes>
        </Router>
      </ModalProvider>
    </div>
  );
}

export default App;
